import { Grid, IconButton, SvgIcon } from '@material-ui/core'
import TextField from '../../../../control/textfield/textfield'
import RichTextEditor from '../../../../control/richTextEditor/richTextEditor'
import Radio from '../../../../control/radio/radio'
import useDocumentTestResult from './useDocumentTestResult'
import { DocumentTestResultViewType, DocumentTestResultCtrlType } from './documentTestResultType'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'
import DatePicker from '../../../../control/datepicker/datepicker'
import React from 'react'
import { ReactComponent as DocumentIcon } from '../../../../images/document.svg'
import ModeAccordion from '../modeAccordion/ModeAccordion'
import { useForm } from 'react-final-form'
import { richEditorRequired } from '../../../../utilities/validate'

const DocumentTestResultView = (props: DocumentTestResultViewType) => {
    const {
        initialData,
        documentLut,
        onChangeRadio,
        selectedCompletely,
        isViewMode,
        navigateToResultHistory,
        useAccordionMode,
        onSubmitEdit,
        onClickModeEdit,
        displayHistory,
    } = props
    const translate = useTranslate()
    const form = useForm()

    const renderChild = (disabled: boolean) => {
        console.log(initialData?.verifyDocumentWithFormat)
        return (
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Radio
                        name="isCompletelyDoc"
                        labelGroup={''}
                        options={documentLut}
                        onChangeValue={onChangeRadio}
                        requiredHalfWidth={true}
                        disabled={disabled}
                        required
                    />
                    {selectedCompletely === '2' && (
                        <React.Fragment>
                            <DatePicker
                                name="resubmitDocDate"
                                label={translate.get('LABEL.DEFINE_RESUBMIT_DOC_DATE')}
                                minDate={new Date()}
                                disabled={disabled}
                                required
                            />
                            <RichTextEditor
                                name={`remarkWithFormat`}
                                disabled={disabled}
                                initialRichTextEditor={initialData?.verifyDocumentWithFormat}
                                label={translate.get('LABEL.REMARK')}
                                placeholder={''}
                                required={true}
                                validates={[richEditorRequired(`${translate.get('MESSAGE.M013')}`)]}
                                isHideToolbar={disabled}
                                topicID={0}
                            />
                            {/* <TextField
                                name="remark"
                                materialInputProps={{
                                    label: translate.get('LABEL.REMARK'),
                                    disabled: disabled,
                                    multiline: true,
                                    rows: 5,
                                }}
                                maxLength={1000}
                                required
                            /> */}
                        </React.Fragment>
                    )}
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            {useAccordionMode ? (
                <ModeAccordion
                    renderEditComponent={() => renderChild(false)}
                    renderViewComponent={() => renderChild(true)}
                    title={translate.get('LABEL.DOCUMENT_REVIEW_RESULT')}
                    additionIcon={
                        displayHistory
                            ? () => (
                                  <IconButton size="small" onClick={navigateToResultHistory}>
                                      <SvgIcon fontSize="small" component={DocumentIcon} />
                                  </IconButton>
                              )
                            : undefined
                    }
                    onConfirm={onSubmitEdit}
                    onClickEdit={onClickModeEdit}
                    fieldNames={['isCompletelyDoc', 'resubmitDocDate', 'remark']}
                    onCancel={() => {
                        onChangeRadio(form.getFieldState('isCompletelyDoc')?.value)
                    }}
                    isViewMode={true}
                />
            ) : (
                <MyAccordion
                    title={translate.get('LABEL.DOCUMENT_REVIEW_RESULT')}
                    titleIcon={
                        displayHistory
                            ? () => (
                                  <IconButton size="small" onClick={navigateToResultHistory}>
                                      <SvgIcon fontSize="small" component={DocumentIcon} />
                                  </IconButton>
                              )
                            : undefined
                    }
                >
                    {renderChild(isViewMode ?? false)}
                </MyAccordion>
            )}
        </>
    )
}

const DocumentTestResultCtrl = (props: DocumentTestResultCtrlType) => {
    const { isViewMode, useAccordionMode, initialData } = props
    const documentTestResultCtrlModel = useDocumentTestResult({ ...props })
    return (
        <DocumentTestResultView
            {...documentTestResultCtrlModel}
            isViewMode={isViewMode}
            useAccordionMode={useAccordionMode}
            initialData={initialData}
        />
    )
}

export default DocumentTestResultCtrl
